var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isInDebugMode)?_c('v-expansion-panel',{staticClass:"red--text"},[_c('v-expansion-panel-header',[_c('div',{staticClass:"debug-name"},[_vm._v("DEBUG: "+_vm._s(_vm.name))])]),_c('v-expansion-panel-content',[_vm._t("default")],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }